import React from "react";

export default function DevicesTable({ devices, onDeviceClick, sortBy, setSortBy }) {
  return (
    <div className="border rounded-lg overflow-hidden">
      <table className="min-w-full text-sm">
        <thead className="bg-gray-50">
          <tr>
            <th 
              className="px-3 py-3 text-left cursor-pointer hover:bg-gray-100"
              style={{ width: "200px" }}
              onClick={() => setSortBy("model")}
            >
              Model 
              {sortBy === "model" && <span className="ml-1">↓</span>}
            </th>
            <th 
              className="px-3 py-3 text-left cursor-pointer hover:bg-gray-100"
              onClick={() => setSortBy("description")}
            >
              Description
              {sortBy === "description" && <span className="ml-1">↓</span>}
            </th>
            <th 
              className="px-3 py-3 text-left cursor-pointer hover:bg-gray-100"
              style={{ width: "100px" }}
              onClick={() => setSortBy("locations")}
            >
              Locations
              {sortBy === "locations" && <span className="ml-1">↓</span>}
            </th>
          </tr>
        </thead>
        <tbody>
          {devices.map((device, idx) => (
            <tr 
              key={idx} 
              className="border-b hover:bg-gray-50 cursor-pointer"
              onClick={() => onDeviceClick(device)}
            >
              <td className="px-3 py-3" style={{ width: "200px" }}>
                <div>
                  <small className="text-gray-500"><b>{device.manufacturer}</b></small>
                  <div>{device.model}</div>
                </div>
              </td>
              <td className="px-3 py-3">
                <div>
                  <h3 className="font-semibold">
                    <span className="text-blue-600 hover:underline cursor-pointer">
                      {device.name}
                    </span>
                  </h3>
                  <p className="text-gray-600 mt-1">{device.description}</p>
                  {device.readMore && (
                    <span className="text-blue-600 hover:underline text-sm cursor-pointer">
                      read more...
                    </span>
                  )}
                </div>
              </td>
              <td className="px-3 py-3" style={{ width: "100px" }}>
                {device.locationCount} locations
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}